export const config = {
  api: {
    /**
     * 默认使用相对路径，交给 Nginx(/api) 或 Vite dev proxy(/api) 转发。
     * 如需覆盖，可在构建时注入 VITE_API_URL。
     */
    baseURL: import.meta.env.VITE_API_URL ?? '/api',
    timeout: Number(import.meta.env.VITE_API_TIMEOUT ?? 5000),
  },
  /**
   * Auth Service 地址。空则使用相对路径 /auth（由 Nginx 或 Vite proxy 转发）。
   * 本地开发时若 auth_service 运行在 3100，可设 VITE_AUTH_URL=http://localhost:3100。
   */
  authBaseURL: import.meta.env.VITE_AUTH_URL ?? '',
};

export type Config = typeof config;

